const createInlineBannerStyle = (background, border, notificationColor) => ({
  root: {
    background,
    border,
    borderRadius: "10px",
    padding: "14px 16px",
    "--notification-color": notificationColor,
  },
});

export const notificationStyles = {
  info: {
    root: {
      background: "#f0f9ff",
      border: "1px solid #bae6fd",
      borderRadius: "12px",
      padding: "20px",
    },
  },

  promo: {
    root: {
      background: "linear-gradient(135deg, #eff6ff 0%, #f0fdf4 100%)",
      border: "1px solid #bfdbfe",
      borderRadius: "12px",
      padding: "20px",
    },
    icon: {
      backgroundColor: "transparent",
      width: "auto",
      height: "auto",
    },
  },
};

export const rotateBannerStyle = createInlineBannerStyle(
  "#fff7ed",
  "1px solid #fdba74",
  "#f97316",
);

export const revokeBannerStyle = createInlineBannerStyle(
  "#fef2f2",
  "1px solid #fca5a5",
  "#f87171",
);

export const secretBannerStyle = createInlineBannerStyle(
  "#fffbeb",
  "1px solid #fde68a",
  "#f59e0b",
);

export const disableBannerStyle = createInlineBannerStyle(
  "#fef2f2",
  "1px solid #fca5a5",
  "#f87171",
);
